import { useContext, useEffect, useState } from 'react';
import './header.css';
import Login from '../../components/login/login/Login';
import Register from '../../components/login/register/Register';
import { UserLoginSecContext } from '../../context/UserLoginSecContext';
import ReactLoading from 'react-loading';
import AccDrop from './accDrop/AccDrop';
import { ReactComponent as MenuIcon } from '../../assets/icons/trvto_menu.svg';
import { ReactComponent as LoginIcon } from '../../assets/icons/trvto_login.svg';
import { ReactComponent as SignUpIcon } from '../../assets/icons/trvto_signup.svg';
import { ReactComponent as PropertyIcon } from '../../assets/icons/trvto_property.svg';
import { ReactComponent as AccountIcon } from '../../assets/icons/trvto_account.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons/trvto_search.svg';
import { UserAuthContext } from '../../context/UserAuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/trvto-logo.png';
import Camp from '../tabsBar/searchComponents/camp';
import TabsBar from '../tabsBar/TabsBar';
import Backpacking from '../tabsBar/searchComponents/backpack';
import Activity from '../tabsBar/searchComponents/activity';
import Guide from '../tabsBar/searchComponents/guide';

export default function Header({ isScrolled }) {
    const enableExtraTabs = process.env.REACT_APP_DISABLE_EXTRA_TABS === 'true';
    const getSelectedTypeFromUrl = (pathname) => {
        const path = pathname.split('/').filter(Boolean);

        const homeUrls = ['', 'camp', 'trip', 'act', 'guide'];
        const isSearchResultPage = path[0] === 'search-result';

        if (isSearchResultPage && path[1]) {
            return path[1];
        }

        if (homeUrls.includes(path[0])) {
            return path[0] || 'trip';
        }

        return 'trip';
    };
    const location = useLocation();
    const [accountDrop, setAccountDrop] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSearch, setIsSearch] = useState(false);
    const navigate = useNavigate();
    const [selectOption, setSelectOption] = useState(getSelectedTypeFromUrl(location.pathname));

    const { isAuthenticated } = useContext(UserAuthContext);
    const { logButton, setLogButton, loginSec, setLoginSec } = useContext(UserLoginSecContext);
    const homeUrls = ['/', '/camp', '/trip', '/act', 'gu'];
    const isHomeUrl = homeUrls.includes(location.pathname);

    useEffect(() => {
        if (accountDrop) {
            document.body.classList.add('modalOpen');
        } else {
            document.body.classList.remove('modalOpen');
        }

        return () => {
            document.body.classList.remove('modalOpen');
        };
    }, [accountDrop]);

    const handleType = (e) => {
        const value = e.target.value;

        // If already on search result page → do NOT navigate
        if (!isHomeUrl) {
            setSelectOption(value); // local state
            return;
        }

        // save current scroll position
        const scrollY = window.scrollY;
        navigate(`/${value}`);

        // restore scroll position after navigation
        setTimeout(() => {
            window.scrollTo(0, scrollY);
        }, 0);
    };

    const getSize = () => {
        if (isAuthenticated) {
            return { width: '53.1vw' };
        }

        if (window.location.pathname !== '/') {
            return {
                width: window.innerWidth <= 1200 ? '38vw' : '40vw'
            };
        }

        return {
            width: window.innerWidth <= 1200 ? '30vw' : '25vw'
        };
    };

    useEffect(() => {
        setAccountDrop(false);
    }, [navigate]);

    useEffect(() => {
        setSelectOption(getSelectedTypeFromUrl(location.pathname));
    }, [location.pathname]);

    const renderSearch = () => {
        return (
            <>
                <div className='tabHidden'>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <select
                            value={selectOption}
                            name='type'
                            onChange={(e) => handleType(e)}
                            className='headerSelect'
                        >
                            <option value='trip'>Trip</option>
                            <option value='camp' disabled={enableExtraTabs}>
                                Camp/Villa
                            </option>
                            <option value='act' disabled={enableExtraTabs}>
                                Activity
                            </option>
                            <option value='gu' disabled={enableExtraTabs}>
                                Guide
                            </option>
                        </select>
                        {selectOption === 'trip' && (
                            <Backpacking className='headerHolidaySearchBar' style={getSize()} type={selectOption} />
                        )}
                        {selectOption === 'camp' && (
                            <Camp className='headerSearchBar' isScrolled={isScrolled} type={selectOption} />
                        )}
                        {selectOption === 'act' && (
                            <Activity className='headerHolidaySearchBar' style={getSize()} type={selectOption} />
                        )}
                        {selectOption === 'gu' && (
                            <Guide className='headerHolidaySearchBar' style={getSize()} type={selectOption} />
                        )}
                    </div>
                </div>
                <button className='headerMenuBtn tabDisplay' onClick={() => setIsSearch(!isSearch)}>
                    <SearchIcon className='headerMenuIcon' />
                </button>
            </>
        );
    };

    return (
        <>
            <div className='preHeader hideOnPrint'>Book now and get up to 50% off — apply TRV50</div>
            <div className='headerWrapper headerContainer hideOnPrint'>
                <Link to='/'>
                    <img alt='trvto logo' src={logo} className='headerLogoImg' />
                </Link>

                <div className='headerTabsEndDiv'>
                    {!isAuthenticated && (
                        <>
                            {window.location.pathname === '/' && isScrolled && renderSearch()}
                            {window.location.pathname !== '/' && renderSearch()}
                            {window.location.pathname === '/' && (
                                <button
                                    type='button'
                                    className='headerBtn listYourPropertyBtn'
                                    onClick={() => navigate('/org/login')}
                                >
                                    <PropertyIcon /> List Your Trips
                                </button>
                            )}
                            <button
                                type='button'
                                name='login'
                                className='headerBtn headerLoginBtn'
                                onClick={() => setLogButton(true)}
                            >
                                <LoginIcon /> Login
                            </button>
                            <button
                                type='button'
                                name='signup'
                                className='headerBtn headerLoginBtn'
                                onClick={() => {
                                    setLogButton(true);
                                    setLoginSec('register');
                                }}
                            >
                                <SignUpIcon /> Sign Up
                            </button>
                        </>
                    )}

                    {isAuthenticated && (
                        <>
                            {isHomeUrl && isScrolled && renderSearch()}

                            {window.location.pathname !== '/' && !isHomeUrl && renderSearch()}

                            <button className='headerMenuBtn' onClick={() => navigate('/account')}>
                                <AccountIcon className='headerMenuIcon' />
                            </button>
                        </>
                    )}
                    {isSearch && <TabsBar className='headerSearch' setIsSearch={setIsSearch} />}
                    <button onClick={() => setAccountDrop(!accountDrop)} className='headerMenuBtn'>
                        <MenuIcon className='headerMenuIcon' />
                    </button>
                    {accountDrop && <div className='headerOverlay' onClick={() => setAccountDrop(false)} />}
                    {accountDrop && (
                        <AccDrop
                            setAccountDrop={setAccountDrop}
                            setLogButton={setLogButton}
                            setLoginSec={setLoginSec}
                        />
                    )}
                </div>
                {logButton && (
                    <div className='loginHeaderPop'>
                        {loginSec === 'login' ? (
                            <Login
                                setLogButton={setLogButton}
                                setLoginSec={setLoginSec}
                                setLoading={setLoading}
                                loading={loading}
                            />
                        ) : loginSec === 'register' ? (
                            <Register
                                setLogButton={setLogButton}
                                setLoginSec={setLoginSec}
                                setLoading={setLoading}
                                loading={loading}
                            />
                        ) : null}
                    </div>
                )}
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}
            </div>
        </>
    );
}
